export const discoverConstants = {
  GET_DISCOVER_ALL_REQUEST: 'DISCOVER/GET_DISCOVER_ALL_REQUEST',
  GET_DISCOVER_ALL_SUCCESS: 'DISCOVER/GET_DISCOVER_ALL_SUCCESS',
  GET_DISCOVER_ALL_FAILURE: 'DISCOVER/GET_DISCOVER_ALL_FAILURE',

  GET_DISCOVER_MIXR_LIST_REQUEST: 'DISCOVER/GET_DISCOVER_MIXR_LIST_REQUEST',
  GET_DISCOVER_MIXR_LIST_SUCCESS: 'DISCOVER/GET_DISCOVER_MIXR_LIST_SUCCESS',
  GET_DISCOVER_MIXR_LIST_FAILURE: 'DISCOVER/GET_DISCOVER_MIXR_LIST_FAILURE',

  GET_DISCOVER_MIXR_LIST_PAGINATION_REQUEST: 'DISCOVER/GET_DISCOVER_MIXR_LIST_PAGINATION_REQUEST',
  GET_DISCOVER_MIXR_LIST_PAGINATION_SUCCESS: 'DISCOVER/GET_DISCOVER_MIXR_LIST_PAGINATION_SUCCESS',
  GET_DISCOVER_MIXR_LIST_PAGINATION_FAILURE: 'DISCOVER/GET_DISCOVER_MIXR_LIST_PAGINATION_FAILURE',

  GET_DISCOVER_GROUP_LIST_PAGINATION_REQUEST: 'DISCOVER/GET_DISCOVER_GROUP_LIST_PAGINATION_REQUEST',
  GET_DISCOVER_GROUP_LIST_PAGINATION_SUCCESS: 'DISCOVER/GET_DISCOVER_GROUP_LIST_PAGINATION_SUCCESS',
  GET_DISCOVER_GROUP_LIST_PAGINATION_FAILURE: 'DISCOVER/GET_DISCOVER_GROUP_LIST_PAGINATION_FAILURE',

  GET_DISCOVER_GROUP_LIST_REQUEST: 'DISCOVER/GET_DISCOVER_GROUP_LIST_REQUEST',
  GET_DISCOVER_GROUP_LIST_SUCCESS: 'DISCOVER/GET_DISCOVER_GROUP_LIST_SUCCESS',
  GET_DISCOVER_GROUP_LIST_FAILURE: 'DISCOVER/GET_DISCOVER_GROUP_LIST_FAILURE'
}
